export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <rect width="32" height="32" rx="8" fill="var(--accent)" />
      <path d="M8.5 22.5c2.2-.2 3.4-2.6 4.7-5.2 1-2 2-3.6 2.9-3.2 1.2.5-1.3 5.4.2 5.8 1 .3 2-2.1 3-2.1.8 0 .4 1.8 1.4 1.8.7 0 1.5-.8 2.8-1.6" fill="none" stroke="var(--accent-ink)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.5 25h15" stroke="var(--accent-ink)" strokeOpacity=".55" strokeWidth="1.4" strokeLinecap="round" />
    </svg>
  );
}

export function MicrosoftMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 21 21" className={className} aria-hidden>
      <rect x="1" y="1" width="9" height="9" fill="var(--ms-red)" />
      <rect x="11" y="1" width="9" height="9" fill="var(--ms-green)" />
      <rect x="1" y="11" width="9" height="9" fill="var(--ms-blue)" />
      <rect x="11" y="11" width="9" height="9" fill="var(--ms-yellow)" />
    </svg>
  );
}
